import { Shield } from "lucide-react";
import { AlertesRupturesSection } from "./sections/AlertesRupturesSection";
import { EpidemiologieSection } from "./sections/EpidemiologieSection";
import { TendancesSection } from "./sections/TendancesSection";
import { SyntheseSection } from "./sections/SyntheseSection";

/**
 * Page Veille Proactive — orchestrateur des 4 sections.
 *
 * Architecture en commits successifs :
 * - 6.1 : stub charte + navigation
 * - 6.2 : Section A — Alertes ruptures personnalisées
 * - 6.3 : Section B — Épidémiologie locale + forecast 7 jours
 * - 6.4 : Section C — Signaux faibles et tendances territoriales
 * - 6.5 : Section D — Synthèse composite de tension sanitaire
 *
 * Charte Cabinet stricte : bordeaux/cream/ink + Playfair pour les titres.
 *
 * Props:
 *   onSwitchToImport — callback optionnel pour rediriger vers la saisie
 *     mensuelle (utilisé par le fallback générique de la Section A quand
 *     la pharmacie n'a pas encore de tickets importés).
 *   onCompleteProfile — callback optionnel pour rediriger vers le profil
 *     (utilisé par la Section B quand le code postal pharmacie est manquant).
 */
export default function VeilleProactivePage({ onSwitchToImport, onCompleteProfile }) {
  return (
    <div className="min-h-screen bg-cabinet-cream" data-testid="veille-proactive-page">
      {/* En-tête noble */}
      <header className="border-b border-cabinet-mute-2/40 bg-cabinet-cream">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10">
          <div className="flex items-center gap-3 mb-3">
            <Shield size={18} className="text-cabinet-bordeaux" strokeWidth={1.6} />
            <span className="text-xs uppercase tracking-[0.2em] text-cabinet-mute-1 font-medium">
              Cabinet Benchory · Module premium
            </span>
          </div>
          <h1 className="font-playfair text-4xl lg:text-5xl text-cabinet-ink font-medium tracking-tight leading-[1.1]">
            Veille Proactive
          </h1>
          <p className="mt-4 text-cabinet-navy text-[15px] leading-relaxed max-w-2xl">
            Une couche d'intelligence stratégique qui croise sept sources publiques
            officielles avec votre activité réelle pour anticiper vos commandes,
            piloter votre stock saisonnier et identifier les signaux faibles avant
            qu'ils ne deviennent des opportunités manquées.
          </p>
        </div>
      </header>

      {/* Corps — les 4 sections de la veille proactive */}
      <main className="max-w-6xl mx-auto px-6 lg:px-10 py-10 space-y-14">
        <SyntheseSection />
        <div className="h-px bg-cabinet-mute-2/40" aria-hidden />
        <AlertesRupturesSection onSwitchToImport={onSwitchToImport} />
        <EpidemiologieSection onCompleteProfile={onCompleteProfile} />
        <TendancesSection />
      </main>
    </div>
  );
}
